// extracted by mini-css-extract-plugin
export var contentBody = "_cm-9";
export var headerImage = "_cm-2";
export var imageButton = "_cm-7";
export var imageButtonIcon = "_cm-8";
export var imageHeader = "_cm-4";
export var imageHeaderText = "_cm-5";
export var imageOverlay = "_cm-3";
export var imageTitle = "_cm-6";
export var imageWrapper = "_cm-1";
export var taskList = "_cm-a";
export var widget = "_cm-0";